import { Bug } from 'lucide-react';

import { Button } from '@shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shared/components/ui/tooltip';

import { useUser } from '@features/user-access/providers/user-provider';

export const DebugInfo = () => {
  const { userAccess } = useUser();

  if (!userAccess.debug) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          aria-label="Mode débug activé"
          className="min-w-10 border-warning text-warning"
          size="sm"
          variant="outline"
        >
          <Bug />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Mode débug activé</TooltipContent>
    </Tooltip>
  );
};
